module.exports = __webpack_public_path__ + "static/logobasico-ba80694f94e311c1bc3cadbae1671089.png";